import React from "react";
import { Bar } from 'react-chartjs-2';
import Card from 'react-bootstrap/Card';
import { useTranslation } from 'react-i18next';

  import "chartjs-plugin-datalabels";
  import {
    Chart as ChartJS,
    CategoryScale,
    
    LinearScale,
    LineElement,
    Title,
    Tooltip,
    Legend,
  } from "chart.js";
  import ChartDataLabels from 'chartjs-plugin-datalabels';
  import 'chart.js/auto';

  ChartJS.register(
    CategoryScale,
    LinearScale,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels // Register the DataLabels plugin
  );
  

  const BarChartOrganisationsPerRegion = (props) => {
    const { t } = useTranslation();
    
   const options = {
  responsive: true,
  maintainAspectRatio: false,
   layout: {
      padding: {
        top: 22,
        right: 22,
        left: 22
      }
    },
   scales: {
    x: {
        display: true,
    },
          y: {
        display: true,
        title: {
          display: true,
          text: t("number_organizations"),
        
           color: "rgb(84, 84, 84)", 
            font: {
              size: 13,
              weight: "500",
            },
        padding: {top: 30, left: 0, right: 0, bottom: 0}
        }
      }
    },
  plugins: {
    legend: {
      display: false,
     position: "bottom",
         onClick: null
    },
         tooltip: {
            displayColors: false,
        callbacks: {
              title: function(context) {
            let title = context[0].label.replace(/[ ,.]/g,' ');
            return title;
              },
          label: function(context) {
            console.log(context)
            let label = context.parsed.y
            return label.toString()
      } 
    }
},
    title: {
      display: true,
        align:'center',
        text: t("regional_distribution"),
      position:'bottom',
       color: "rgb(84, 84, 84)", 
            font: {
              size: 14,
              weight: "500",
            },
    },
      datalabels: {
          align: 'end',
            anchor: 'end',
            color: "black", 
            font: {
              size: 14,
              weight: "500",
            },
  },
},

  };
    const mobileLabels = ['AF', "AS", "EU", "LAC", "NE", "NA", ];

 const labels = props.size.x > 600 ? [ 
  t("region_africa").split(" "), 
  t("region_asia").split(" "),
  t("region_europe").split(" "), 
  t("region_lac").split(" "),
  t("region_neareast").split(" "),
  t("region_north_america").split(" "),
  t("region_swpacific").split(" ")] : mobileLabels;
 
 
 const fullRegionNames =  [ 
  t("region_africa"), 
  t("region_asia"),
  t("region_europe"), 
  t("region_lac"),
  t("region_neareast"),
  t("region_north_america"),
  t("region_swpacific")];


  



  
const dataSet = {
  labels,
 datasets: [
    {
        label: "",
        backgroundColor : "rgb(138, 206, 126)",
        data: props.data
    }
 ]
};

    return (
      <div >

      <Card className="card-padding">
      <Card.Header className="big-container-header card-title"><p className="vertical-center">{t(props.graphTitle)}</p></Card.Header>
      <Card.Body> 
        {props.data !== "" && props.data !== undefined &&
        <div className={props.isSubquestion ? "graph-div-subquestion" : "graph-div-main"}>
           <Bar  options={options} data={dataSet} className="graph-height-mobile"/>
                
                <div className="mobile-legend">
                 {mobileLabels.map((acr, index) => 
                   <p key={acr+index} style={{fontSize: "10px", margin: "0px"}}>{acr + ": " + fullRegionNames[index]}</p>
                  )}
                 </div>
         </div>}
       </Card.Body>
    </Card> 


   
      </div>
    );
  };
  
  export default BarChartOrganisationsPerRegion;